import CustomCard from '../../components/UIComponents/CustomCard';
import GuestReservationDetails from './components/GuestReservationDetails';
import HeaderComponent from "../../components/Header"
import TitleCard from '../../components/TIttleCard';
import { Box, Grid } from '@mui/material';
import PaymentList from './components/PaymentList';
import AvailedServices from '../Reservation/Components/AvailedSeverice';
import InvoiceList from './components/InvoiceList';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getReportData, getReservationDetails, getUnallocatedAmount } from '../../service/network';
import moment from 'moment/moment';
import { mergeReportData } from '../../helpers/functions';

export default function Payment_Invoice() {

    const location = useLocation();
    const navigate = useNavigate();
    const { details } = location.state || {};
    const [invoices, setInvoices] = useState([]);
    const [resdetails, setReservationDetails] = useState(null);
    const [entries, setEntries] = useState([]);
    const [unalloc, setUnalloc] = useState(0);

    const getInvoices = () => {
        getReportData({
            doctype: "Sales Invoice",
            filters: [["reservation", "=", details.reservation_id]],
            fields: ["name", "customer", "status", "posting_date", "grand_total", "outstanding_amount"]
        }).then((resp) => {
            if (resp.data.message && (!Array.isArray(resp.data.message))) {
                let merged_invoices = mergeReportData(resp.data.message.keys, resp.data.message.values);
                setInvoices(merged_invoices);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const getPaymentTransactions = () => {
        let params = {
            doctype: 'Reservation Payment',
            fields: JSON.stringify(["name", "creation", "remarks", "type", "mode_of_payment", "amount"]),
            filters: JSON.stringify({ reservation: details.reservation_id }),
        }
        fetchUnallocatedAmountReservation();
        getReportData(params).then((resp) => {
            if (resp.data?.message && (!Array.isArray(resp.data?.message))) {
                setEntries(resp.data?.message?.values);
            } else {
                setEntries([]);
            }
            // setEntries(resp.data?.message?.values ? resp.data?.message?.values : []);
        }).catch((err) => {
            console.log(err);
        })
    }

   // In your Payment_Invoice component
const refresh = () => {
    getInvoices();
    getPaymentTransactions();
    fetchUnallocatedAmountReservation(); // This should update unallocated amount
    getReservationDetails(details?.reservation_id).then((resp) => {
        setReservationDetails(resp.data.data);
        console.log(resp.data);
    }).catch((err) => {
        console.log(err);
    })
}

const fetchUnallocatedAmountReservation = () => {
    getUnallocatedAmount({ reservation: details.reservation_id }).then((res) => {
        setUnalloc(res.data.message.unallocated); // This updates the state that gets passed as prop
    }).catch((err) => {
        console.log(err);
    })
}

    useEffect(() => {
        if (details?.reservation_id) {
            refresh();
        }
    }, [details]);

    return (
        <Box sx={{ width: '100%', p: 2 }}>
            <HeaderComponent title="Payment & Invoice" />
            <TitleCard
                reservationId={resdetails?.name}
                checkIn={moment(resdetails?.from_date).format("MMM DD, YYYY")}
                checkOut={moment(resdetails?.to_date).format("MMM DD, YYYY")}
                status={resdetails?.payment_status}
            />

            <CustomCard
                bgColor="light"
                shadow="lg"
                borderRadiusbottom="xxl"
                sx={{
                    width: '100%',
                    minHeight: 800,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0, // Set top-right corner to 0
                    borderBottomLeftRadius: (theme) => theme.shape.borderRadius.xxl,
                    borderBottomRightRadius: (theme) => theme.shape.borderRadius.xxl,
                }}
            >

                <GuestReservationDetails details={resdetails} />

                <Grid container spacing={2} mt={2}>
                    {/* Left side: Payment List */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <PaymentList reservation_id={resdetails?.name} records={entries} refresh={refresh} unallocated={unalloc} />
                    </Grid>

                    {/* Right side: Availed Services */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <AvailedServices showDateField={false} showAddButton={false} services={resdetails?.addon_services ?? []} />
                    </Grid>
                </Grid>
                <InvoiceList
                    invoices={invoices}
                    refresh={() => { refresh(); }}
                    addInvoice={() => {
                        navigate('/add/payment', { state: { details: details } });
                    }} />

            </CustomCard>
        </Box>
    );
}
